import { ArrowLeft } from "lucide-react";
import { Button } from "../ui/button";

export default function RecruiterPageShell({
  title,
  subtitle,
  onBack,
  backLabel = "Back to Dashboard",
  actions,
  children,
  className = "",
}) {
  return (
    <div className={`min-h-screen py-6 sm:py-8 lg:py-10 relative bg-transparent ${className}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-8 flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4">
          <div className="space-y-2">
            {onBack && (
              <Button
                variant="ghost"
                size="sm"
                className="px-0 h-auto text-muted-foreground hover:text-primary -ml-1"
                onClick={onBack}
              >
                <ArrowLeft className="w-4 h-4 mr-1.5" />
                {backLabel}
              </Button>
            )}
            <h1 className="text-3xl sm:text-4xl font-bold text-brand-gradient">
              {title}
            </h1>
            {subtitle && (
              <p className="text-base sm:text-lg text-muted-foreground max-w-2xl">{subtitle}</p>
            )}
          </div>
          {actions && <div className="flex flex-wrap gap-2 shrink-0">{actions}</div>}
        </div>
        {children}
      </div>
    </div>
  );
}
